import { StyledPagination } from './Pagination.style';
import { setSearchCondition } from '~/store/resource';
import { useAppDispatch } from '~/store';
type paginationType = {
  totalResourcesCount: number;
  pageSize: number;
  page: number;
  onChange?: (count: number) => void;
};

export const Pagination = (props: paginationType) => {
  const { pageSize, page, onChange } = props;

  const dispatch = useAppDispatch();
  const changePage = (count: number) => {
    if (onChange) {
      onChange(count);
      return;
    }
    dispatch(
      setSearchCondition({
        pageSize,
        page: count,
      }),
    );
  };

  return (
    <StyledPagination
      count={props.totalResourcesCount}
      page={page}
      onChange={(event: React.ChangeEvent<unknown>, count: number) =>
        changePage(count)
      }
    />
  );
};
